import React from "react";

// Active locale for code outside React (share text, data fetches, date
// formatting). LocaleProvider sets it on render, before any child runs.
let active = { locale: "en", messages: {} };

export function setRuntimeLocale(locale, messages) {
  active = { locale, messages };
}

export function getLocale() {
  return active.locale;
}

export function t(key, vars) {
  return formatMessage(active.messages[key], vars);
}

// "{count} possible answers" + { count: 5 } -> "5 possible answers"
export function formatMessage(message, vars = {}) {
  return message.replace(/\{(\w+)\}/g, (match, name) => vars[name]);
}

// Like formatMessage, but returns React nodes: <b>…</b> becomes <strong>,
// and {vars} may be React elements (links, etc).
export function richText(message, vars = {}) {
  return message.split(/<b>(.*?)<\/b>/).map((part, i) => {
    const nodes = part
      .split(/\{(\w+)\}/)
      .map((piece, j) =>
        j % 2 === 1 ? (
          <React.Fragment key={j}>{vars[piece]}</React.Fragment>
        ) : (
          piece
        )
      );

    return i % 2 === 1 ? (
      <strong key={i}>{nodes}</strong>
    ) : (
      <React.Fragment key={i}>{nodes}</React.Fragment>
    );
  });
}

export function createT(messages) {
  const translate = (key, vars) => formatMessage(messages[key], vars);
  translate.rich = (key, vars) => richText(messages[key], vars);

  return translate;
}
